module.exports = __webpack_public_path__ + "static/img/1.817774f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newSeven/1.png
// module id = hEAy
// module chunks = 0